import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import type { SelectProps } from 'aui';
import { Select } from 'aui';
import { FoxIconGlobe1 } from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';
import styles from './EnvironmentSelect.module.css';

export type EnvironmentSelectProps = Pick<SelectProps, 'size' | 'bordered' | 'variant'> & {
  className?: string;
  selectClassName?: string;
};

export function EnvironmentSelect(props: EnvironmentSelectProps) {
  const { bordered, size, className, selectClassName, variant } = props;

  const environmentList = useDocsDataModelStore((x) => x.environments.environmentList);
  const selectedEnvironment = useDocsDataModelStore((x) => x.environments.selectedEnvironment);
  const selectEnvironment = useDocsDataModelStore((x) => x.selectEnvironment);

  const options = React.useMemo(() => {
    return environmentList?.map((x) => ({
      label: (
        <span className="flex items-center truncate">
          <FoxIconGlobe1
            className={clsx('mr-1.5', {
              ['text-input']: size === 'small',
              ['text-input-icon']: size !== 'small',
            })}
          />
          <span
            className={clsx('truncate', {
              ['mr-1']: size !== 'small',
            })}
          >
            {x.name}
          </span>
        </span>
      ),
      value: x.id,
    }));
  }, [environmentList, size]);

  return (
    <div className={clsx(className)}>
      <Select
        className={clsx(selectClassName, styles.select)}
        size={size}
        options={options}
        value={selectedEnvironment?.id}
        onChange={(e) => selectEnvironment(e)}
        bordered={bordered}
        variant={variant}
        dropdownMatchSelectWidth={false}
      />
    </div>
  );
}
